export interface IColorEntry {
  background: string;
  text: string;
  label: string;
}

export interface IProductsConfig {
  products: Record<string, IColorEntry>;
  interventions: Record<string, IColorEntry>;
  transition: IColorEntry;
  default: IColorEntry;
}

export const DEFAULT_PRODUCTS_CONFIG: IProductsConfig = {
  products: {
    'SP95':      { background: '#00B050', text: '#FFFFFF', label: 'SP95' },
    'SP95/ETH':  { background: '#00B050', text: '#FFFFFF', label: 'SP95/ETH' },
    'SP95 été':  { background: '#00B050', text: '#FFFFFF', label: 'SP95 été' },
    'SP98':      { background: '#7030A0', text: '#FFFFFF', label: 'SP98' },
    'GO':        { background: '#F9A825', text: '#1B3D6F', label: 'GO' },
    'GOH':       { background: '#F9A825', text: '#1B3D6F', label: 'GOH' },
    'GOB0':      { background: '#FDD835', text: '#1B3D6F', label: 'GOB0' },
    'GOP':       { background: '#FFB300', text: '#1B3D6F', label: 'GOP' },
    'GOPECH':    { background: '#FFB300', text: '#1B3D6F', label: 'GOPECH' },
    'FOD':       { background: '#78909C', text: '#FFFFFF', label: 'FOD' },
    'ETH':       { background: '#26A69A', text: '#FFFFFF', label: 'ETH' },
    'JET A-1':   { background: '#5C6BC0', text: '#FFFFFF', label: 'JET A-1' },
    'HVO':       { background: '#66BB6A', text: '#FFFFFF', label: 'HVO' },
    'EMAG':      { background: '#8D6E63', text: '#FFFFFF', label: 'EMAG' },
    'REAF':      { background: '#00BCD4', text: '#FFFFFF', label: 'REAF' },
  },
  interventions: {
    'VND':        { background: '#FF9800', text: '#FFFFFF', label: 'Vidange' },
    'OD':         { background: '#F44336', text: '#FFFFFF', label: 'Arrêt' },
    'TVX':        { background: '#E91E63', text: '#FFFFFF', label: 'Travaux' },
    'EPREUVE':    { background: '#9C27B0', text: '#FFFFFF', label: 'Épreuve' },
    'réaf':       { background: '#00BCD4', text: '#FFFFFF', label: 'Réaffectation' },
    'répa purge': { background: '#FF5722', text: '#FFFFFF', label: 'Répa. purge' },
  },
  transition: { background: '#FFC107', text: '#1B3D6F', label: 'Transition' },
  default:    { background: '#E1E4E8', text: '#24292E', label: '' },
};
